// extracted by mini-css-extract-plugin
export default {"dropzoneBox":"tA6njVCaUIetZB4UYgpw","dragging":"H01c2uokaEgVEVRR9HVM","error":"A9SK6CaNDgLjFBEjAUXR","infoBox":"xWOMNdF8IU9E1L3ql4xS"};